import { getClient, getClients } from "@/apis/clients";
import { notifyError } from "@/helpers/notification";

export default {
  data() {
    return {
      isLoadingClientOptions: false,
      allClientOptions: [],
      preferAllClientOptions: false,
    };
  },
  methods: {
    addSelectedClientContact() {
      if (!this.selectedContactToAdd) return;

      // Avoid adding duplicate contacts
      const exists = this.contacts.some(
        (c) => c.id && c.id === this.selectedContactToAdd.id
      );

      if (exists) {
        notifyError(this, "This contact has already been added.");
        this.selectedContactToAdd = null;
        return;
      }

      // If the first row is completely empty/blank, replace it reactively using Vue.set
      if (this.contacts.length === 1 && !this.contacts[0].name) {
        this.$set(this.contacts, 0, { ...this.selectedContactToAdd });
      } else {
        this.contacts.push({ ...this.selectedContactToAdd });
      }

      // Reset picker selection
      this.selectedContactToAdd = null;
    },
    async clientSelected(client_id) {
      if (!client_id || client_id === "other") {
        if (client_id === "other") {
          this.preferAllClientOptions = true;
        }
        return;
      }

      this.selectedContactToAdd = null;

      try {
        const { data } = await getClient(client_id);
        if (
          data.contacts &&
          Array.isArray(data.contacts) &&
          data.contacts.length > 0
        ) {
          // Map new contacts
          const newContacts = data.contacts.map((c) => ({
            text: `${c.name} (${c.email || "No email"})`,
            value: c,
          }));

          // Merge with existing available contacts, avoiding duplicates by contact id
          const existingIds = new Set(
            this.clientAvailableContacts.map((item) => item.value.id)
          );

          const uniqueNewContacts = newContacts.filter(
            (item) => !existingIds.has(item.value.id)
          );

          // Append to the list instead of overwriting
          this.clientAvailableContacts = [
            ...this.clientAvailableContacts,
            ...uniqueNewContacts,
          ];
        }
      } catch (err) {
        notifyError(this, err?.response?.data);
      }
    },
    async getClientOptions() {
      this.isLoadingClientOptions = true;

      let clientOptions = [];

      await getClients()
        .then(({ data }) => {
          clientOptions = data.map((c) => ({
            text: c.name,
            value: c.id,
          }));
        })
        .catch((err) => {
          notifyError(this, err?.response?.data);
        });

      this.allClientOptions = clientOptions;

      const invoicingClientFieldIndex = this.fields.findIndex(
        (f) => f.name === "invoicing_client"
      );
      if (invoicingClientFieldIndex >= 0)
        this.$set(
          this.fields[invoicingClientFieldIndex],
          "options",
          this.allClientOptions
        );

      this.isLoadingClientOptions = false;
    },
  },
  computed: {
    relevantClientOptions() {
      if (this.preferAllClientOptions || !this.vessels || !this.vessels.length)
        return this.allClientOptions;

      const options = [];

      if (this.vessel_clients && this.vessel_clients.length) {
        const clientIds = this.vessel_clients.map((vc) => vc.client_id);
        const clientOptionsToAdd = this.allClientOptions.filter((co) =>
          clientIds.includes(co.value)
        );
        options.push(...clientOptionsToAdd);
      }

      if (this.details.client_id) {
        if (!options.some((o) => o.value === this.details.client_id)) {
          const clientOptionToAdd = this.allClientOptions.find(
            (co) => co.value === this.details.client_id
          );
          if (clientOptionToAdd) {
            options.push(clientOptionToAdd);
          }
        }
      }

      if (this.details.invoicing_client?.id) {
        if (
          !options.some((o) => o.value === this.details.invoicing_client.id)
        ) {
          const clientOptionToAdd = this.allClientOptions.find(
            (co) => co.value === this.details.invoicing_client.id
          );
          if (clientOptionToAdd) {
            options.push(clientOptionToAdd);
          }
        }
      }

      if (options.length === 0) return this.allClientOptions;

      options.push({ text: "Other", value: "other" });

      return options;
    },
  },
  mounted() {
    this.getClientOptions();
  },
};
